function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from 'react';
var useFilteredServiceOptions = function useFilteredServiceOptions(_ref) {
  var serviceOptions = _ref.serviceOptions;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    filteredServiceOptions = _useState2[0],
    setFilteredServiceOptions = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    serviceIdentity = _useState4[0],
    setServiceIdentity = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    figureCount = _useState6[0],
    setFigureCount = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    tableCount = _useState8[0],
    setTableCount = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    wordCount = _useState10[0],
    setWordCount = _useState10[1];
  var tableCountRequired = !!filteredServiceOptions.find(function (serviceOption) {
    return serviceOption.tableCount > 0;
  });
  var figureCountRequired = !!filteredServiceOptions.find(function (serviceOption) {
    return serviceOption.figureCount > 0;
  });
  var wordCountRequired = !!filteredServiceOptions.find(function (serviceOption) {
    return serviceOption.wordCount.max > 0;
  });
  var clearSelection = function clearSelection() {
    setFigureCount(null);
    setServiceIdentity(null);
    setTableCount(null);
    setWordCount(null);
  };
  var handleServiceIdentityUpdate = function handleServiceIdentityUpdate(serviceIdentity) {
    setServiceIdentity(serviceIdentity);
    setTableCount(null);
    setFigureCount(null);
  };
  useEffect(function () {
    var filteredServiceOptions = serviceOptions.filter(function (option) {
      return serviceIdentity ? serviceIdentity.value === option.serviceIdentity : true;
    }).filter(function (option) {
      return figureCount ? figureCount.value === option.figureCount : true;
    }).filter(function (option) {
      return tableCount ? tableCount.value === option.tableCount : true;
    }).filter(function (option) {
      return wordCount ? wordCount.value === option.wordCount.max : true;
    });
    setFilteredServiceOptions(filteredServiceOptions);
  }, [serviceOptions, serviceIdentity, figureCount, tableCount, wordCount]);
  return {
    clearSelection: clearSelection,
    filteredServiceOptions: filteredServiceOptions,
    filters: {
      figureCount: figureCount,
      serviceIdentity: serviceIdentity,
      wordCount: wordCount,
      tableCount: tableCount
    },
    requires: {
      wordCount: wordCountRequired,
      figureCount: figureCountRequired,
      tableCount: tableCountRequired
    },
    setFilter: {
      serviceIdentity: handleServiceIdentityUpdate,
      wordCount: setWordCount,
      figureCount: setFigureCount,
      tableCount: setTableCount
    }
  };
};
export default useFilteredServiceOptions;